import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { T } from 'src/assets/i18n/translation-keys';
import { FilterTypes } from '../../../enums/filterTypes';
import { FilterViewModel } from '../../../models/filter/filterViewModel';
import { CommentsService } from '../../../services/comments.service';
import { Subscription } from 'rxjs';
import { EmployeeViewModel } from '../../../viewModels/employeeViewModel';

@Component({
    selector: 'app-filters-inline-edit-lozenges',
    templateUrl: './filters-inline-edit-lozenges.component.html',
    styleUrls: ['./filters-inline-edit-lozenges.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class.filters-inline-edit-lozenges-disabled]': 'disabled',
    },
    standalone: false
})
export class FiltersInlineEditLozengesComponent implements OnInit, OnDestroy, OnChanges {
  @Input() appliedFilters: FilterViewModel[];
  @Input() filters: FilterViewModel[] = [];
  @Input() label: string;
  @Input() showHeader: boolean = false;
  @Input() filterType: FilterTypes;
  @Input() canClickOnStar: boolean = true;
  @Input() disabled: boolean = false;
  @Input() canRemove: boolean = true;

  @Output() filterRemoved: EventEmitter<FilterViewModel> = new EventEmitter();
  @Output() makePrimary: EventEmitter<FilterViewModel> = new EventEmitter();

  public readonly T = T;
  public readonly filterTypes = FilterTypes;
  public isPrimaryIconHovered = false;
  /**
   * Used to show avatar icons for filters with FilterType.Owner
   */
  public availableEmployees: EmployeeViewModel[] = [];
  private subscription = new Subscription();
  public enrichedFilters: FilterViewModel[] = [];

  constructor(private readonly commentsService: CommentsService, private readonly cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.initAvailableEmployees();
    this.removeDuplicateFilters();
    this.prepareFilters();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.removeDuplicateFilters();
    if (changes['appliedFilters']) {
      this.prepareFilters();
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private prepareFilters(): void {
    this.enrichedFilters = this.appliedFilters.map(filter => ({
      ...filter,
      filterText: this.getFilterText(filter)
    }));
  }

  removeDuplicateFilters(): void {
    const uniqueMap = new Map(
      this.appliedFilters.map(f => [f.filterValue, f])
    );

    this.appliedFilters = [...uniqueMap.values()];
    this.cdr.markForCheck();
  }

  public getFilterText(filter: FilterViewModel): string {
    if (filter.filterText?.trim()) {
      return filter.filterText;
    }

    const found = this.filters?.find(f =>
      f.filterType === filter.filterType &&
      f.filterValue === filter.filterValue
    );

    return found?.filterText?.trim() || filter.filterValue?.toString() || '';
  }

  public get isPrimaryFunctionalityAllowed(): boolean {
    return this.canClickOnStar && this.filterType == FilterTypes.Department;
  }

  onFilterRemove(filter: FilterViewModel): void {
    // this.appliedFilters = this.appliedFilters.filter(f => f.id !== filter.id);
    this.filterRemoved.emit(filter);
  }

  onPrimaryClick(filter: FilterViewModel): void {
    if (filter.isPrimary) {
      filter.isPrimary = false;
    } else {
      filter.isPrimary = true;
    }
    this.makePrimary.emit(filter);
  }

  onClose(): void {
    document.dispatchEvent(new KeyboardEvent('keydown', { key: 'escape' }));
    window.dispatchEvent(new KeyboardEvent('keydown', { key: 'escape' }));
  }

  private initAvailableEmployees() {
    if(this.filterType === FilterTypes.Owner) {
      this.subscription.add(
        this.commentsService.getAllEmployeesByAccountId().subscribe((res) => {
          this.availableEmployees = res;
          this.cdr.detectChanges();
        })
      );
    }
  }
  public getEmployee(employeeId: number): EmployeeViewModel {
    return this.availableEmployees.find((employee) => employee.id == employeeId);
  }
}
